/* eslint-disable no-undef */
import React, {
  Fragment, useEffect, useState, useRef,
} from 'react';
import { useParams, useHistory } from 'react-router-dom';
import './index.css';
import Storage from 'localStorage';
import RobotImage from '../../../assests/img/robot_chat_image.png';
import useMessage from '../useMessage';
import Loader from '../../../components/loader';
import Send from '../../../components/icons/send';
import avatarDefault from '../../../assests/img/avatar-default.png';
import {
  defaultAvatar, isValidUrl, scrollDown, isImageWithText,
} from '../../../utils/Utils';
import Translate from '../../../utils/Translate';
import useProjectStore from '../../../hooks/store/useProjectStore';

export default function ChatSupport() {
  const uid = Storage.getItem('uid');
  const token = Storage.getItem('token');
  if (!uid && !token) {
    window.location = '/';
  }

  const params = useParams();
  const chatRef = useRef(null);
  const containerRef = useRef(null);
  const { location } = useHistory();
  const [value, setValue] = useState('');

  const { onSubmitMessage, submiting } = useMessage();
  const {
    getChatHistory, onChangeChatValue, user, loadingHistory, projectHistory,
  } = useProjectStore();

  useEffect(() => {
    setTimeout(() => {
      scrollDown({ contentRef: containerRef, scrollRef: chatRef });
    }, 200);
  }, [chatRef, containerRef, projectHistory, value]);

  useEffect(() => {
    getChatHistory({ chatUid: params.uid });
    setValue('');
  }, [params.uid]);

  const onChageValue = (e) => {
    setValue(e.target.value);
  };

  const onSubmit = () => {
    setValue('');
    onChangeChatValue(value);
    onSubmitMessage({
      uid: params.uid,
      content: value,
      callback: (error) => {
        if (error) {
          const errorMessage = Translate.get('messageError520', 'I had an issue, give me minute to get back to you, please');
          onChangeChatValue(errorMessage);
          setTimeout(() => {
            getChatHistory({ chatUid: params.uid, initialLoading: false, retry: true });
          }, 1000);
        } else {
          getChatHistory({ chatUid: params.uid, initialLoading: false, retry: false });
        }
      },
    });
  };

  const onKeyDown = (event) => {
    if (event.keyCode === 13 && !event.shiftKey) { onSubmit(); }
  };

  const searchParams = new URLSearchParams(location.search.substring(location.search.indexOf('?')));
  const projectName = searchParams.get('project') || '';
  const sortedMessages = projectHistory && projectHistory
    .sort((a, b) => new Date(a.inserted_at).getTime() - new Date(b.inserted_at).getTime());
  const filteredMessages = sortedMessages.filter(item => item.role !== 'system');

  return (
    <div className="chat-container">
      <h2 className="chat-container-title">{projectName}</h2>
      <div className="chat-container-user" ref={containerRef}>
        {loadingHistory ? <Loader style={{ zIndex: 1 }} />
          : (
            <Fragment>
              {filteredMessages.map((chat) => {
                const validateUrl = isValidUrl(chat.content);
                const message = isImageWithText(chat.content);
                return (
                  <div
                    key={new Date(chat.inserted_at).getTime()}
                    className="chat-container-support"
                  >
                    {chat.role === 'user' ? (
                      <figure>
                        <img
                          alt="foto"
                          src={user ? user.img : avatarDefault}
                          onError={e => defaultAvatar(e, avatarDefault)}
                          style={{minWidth: 50}}
                        />
                      </figure>
                    ) : (
                      <figure>
                        <img src={RobotImage} alt="logo" style={{minWidth: 50}}/>
                      </figure>
                    )}
                    {validateUrl ? (
                      <a
                        className="chat-container-support-image"
                        href={chat.content}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img alt="seenapse-logo" src={chat.content} />
                      </a>
                    )
                      : (
                        <div width="80%" >
                          <p>{message.content}</p>
                          {message.url && (
                          <a
                            className="chat-container-support-image"
                            href={chat.content}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <figure style={{ maxWidth: '100%' }}>
                              <a href={message.url} target="_blank" ><img alt="seenapse-logo" src={message.url} className="image-chat" /></a>
                            </figure>
                          </a>
                          )}
                        </div>
                      )
                    }
                  </div>
                );
              })}
              <div ref={chatRef} />
            </Fragment>
          )}
      </div>
      <div className={value ? 'chat-container-send chat-area-value' : 'chat-container-send'}>
        <textarea
          placeholder="Message Pinn"
          value={value}
          disabled={submiting}
          onKeyDown={onKeyDown}
          onChange={onChageValue}
          className="chat-container-send-area"
        />
        <Send disabled={!value || submiting} isLoading={submiting} onClick={() => onSubmit()} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/projects/chat/index.js